module.exports = __webpack_public_path__ + "img/envelope_magic_link.9f45eee8.png";